<template>
  <app-step-template :step="2">
    <template #title>
      Confirmation
    </template>
    <template #buttons>
      <button class="--sm lips" @click="print">Print</button>

      <router-link :to="{ name: 'add-dependent', params: { primarySubscriberMemberCk: primarySubscriberMemberCk } }" class="_mlxs btn lips --sm">Add Dependent</router-link>
      <router-link :to="{ name: 'add-new-family' }" class='_mlxs btn lips --sm'>Add Another Subscriber</router-link>
    </template>
    <template #content>
      <slot></slot>
    </template>
  </app-step-template>
</template>

<script>
  import AppStepTemplate from './StepTemplate.vue'

  export default {
    components: {
      AppStepTemplate
    },
    methods: {
      print() {
        window.print()
      }
    },
    computed: {
      primarySubscriberMemberCk() {
        return this.$store.getters['hiddenRouteData/getHiddenRouteData'].primarySubscriberMemberCk
      }
    }
  }
</script>
